import * as Yup from 'yup';

import editarEmployeFormModel from './editarEmployeFormModel';

const {

  formField: {

    // DATOS CLIENTE 
    e_document_type,
    e_document_number,
    e_expedition_place,
    e_name,
    e_last_name,
    e_date_of_birth,
    e_gender,
    e_civil_status,
    e_landline,
    e_cell_phone,
    e_whatsapp,
    e_rh,
    e_dominance,
    e_allergies,
    e_cedula,
    e_cv,
    e_housing_type,
    e_neighborhood,
    e_stratum,
    e_cost_center,
    e_compani,
    e_work_headquarters,
    e_cargo,
    e_scholarship,
    e_institution,
    e_degree,
    e_address,
    e_email,


    // LABORAL 
    e_type_contract,
    e_salary_base,
    e_payment_method,
    e_frecuency_payment,
    e_associated_bank,
    e_certificate_bank,
    e_account_number,
    e_date_start_contract,
    e_vacation_acumulate,
    e_bonification_aditional,
    e_dayrest,


    // SEGURIDAD SOCIAL 
    e_eps,
    e_familyCompensation,
    e_fileCajaCompensacion,
    e_cesantias,
    e_fileCesantias,
    e_pension,
    e_fileArl,
    // DOTACION 
    // items,


  }

} = editarEmployeFormModel;


export default [

  // INFORMACION BASICA 
  Yup.object().shape({ 
    [e_document_type.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined)
    .required(`${e_document_type.requiredErrorMsg}`),
    [e_name.name]: Yup.string().required(`${e_name.requiredErrorMsg}`),    
    [e_document_number.name]: Yup.number().typeError('El numero documento debe ser numerico').label(`${e_document_number.typeDataMsg}`).required(`${e_document_number.requiredErrorMsg}`),
    [e_last_name.name]: Yup.string().required(`${e_last_name.requiredErrorMsg}`),
    [e_date_of_birth.name]: Yup.string().required(`${e_date_of_birth.requiredErrorMsg}`),
    [e_expedition_place.name]: Yup.string().required(`${e_expedition_place.requiredErrorMsg}`),
    [e_gender.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined)
    .required(`${e_gender.requiredErrorMsg}`),
    [e_civil_status.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined)
    .required(`${e_civil_status.requiredErrorMsg}`),
    [e_landline.name]: Yup.string().nullable(),
    [e_cell_phone.name]: Yup.string().required(`${e_cell_phone.requiredErrorMsg}`),
    [e_whatsapp.name]: Yup.boolean(),
    [e_rh.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined)
    .required(`${e_rh.requiredErrorMsg}`),
    [e_dominance.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined)
    .required(`${e_dominance.requiredErrorMsg}`),
    [e_allergies.name]: Yup.string().nullable(), 
    // [e_cedula.name]: Yup.string().required(`${e_cedula.requiredErrorMsg}`),
    [e_housing_type.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined)
    .required(`${e_housing_type.requiredErrorMsg}`), 
    // [e_cv.name]: Yup.string().required(`${e_cv.requiredErrorMsg}`),
    [e_address.name]: Yup.string().required(`${e_address.requiredErrorMsg}`),
    [e_neighborhood.name]: Yup.string().required(`${e_neighborhood.requiredErrorMsg}`),
    [e_stratum.name]: Yup.string().required(`${e_stratum.requiredErrorMsg}`),
    [e_cost_center.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined)
    .required(`${e_cost_center.requiredErrorMsg}`),
    // [e_compani.name]: Yup.object().shape({
    //   value: Yup.string().required(),
    //   label: Yup.string().required()
    // }).default(undefined)
    // .required(`${e_compani.requiredErrorMsg}`),
    [e_work_headquarters.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined)
    .required(`${e_work_headquarters.requiredErrorMsg}`),
    [e_cargo.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined)
    .required(`${e_cargo.requiredErrorMsg}`),
    [e_scholarship.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined)
    .required(`${e_scholarship.requiredErrorMsg}`),
    [e_institution.name]: Yup.string().required(`${e_institution.requiredErrorMsg}`),
    [e_degree.name]: Yup.string().required(`${e_degree.requiredErrorMsg}`),
    [e_email.name]: Yup.string().required(`${e_email.requiredErrorMsg}`).email(`${e_email.requiredErrorMsg}`)
  }),

  // LABORAL 
  Yup.object().shape({

    [e_type_contract.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined)
    .required(`${e_type_contract.requiredErrorMsg}`),
    [e_payment_method.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined)
    .required(`${e_payment_method.requiredErrorMsg}`),
    [e_frecuency_payment.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined)
    .required(`${e_frecuency_payment.requiredErrorMsg}`),
    [e_document_number.name]: Yup.number().typeError('El numero documento debe ser numerico').label(`${e_document_number.typeDataMsg}`).required(`${e_document_number.requiredErrorMsg}`),
    [e_associated_bank.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined)
    .required(`${e_associated_bank.requiredErrorMsg}`),
    // [e_certificate_bank.name]: Yup.string().required(`${e_certificate_bank.requiredErrorMsg}`),

    [e_account_number.name]: Yup.string().required(`${e_account_number.requiredErrorMsg}`),
    [e_vacation_acumulate.name]: Yup.number().typeError('El numero documento debe ser numerico').label(`${e_vacation_acumulate.typeDataMsg}`).required(`${e_vacation_acumulate.requiredErrorMsg}`),
    [e_bonification_aditional.name]: Yup.number().typeError('El numero documento debe ser numerico').label(`${e_bonification_aditional.typeDataMsg}`).required(`${e_bonification_aditional.requiredErrorMsg}`),
    [e_date_start_contract.name]: Yup.string().required(`${e_date_start_contract.requiredErrorMsg}`),
    [e_salary_base.name]: Yup.number().typeError('El numero documento debe ser numerico').label(`${e_salary_base.typeDataMsg}`).required(`${e_salary_base.requiredErrorMsg}`),
  }),

  // // SEGURIDAD SOCIAL 
  Yup.object().shape({

    [e_eps.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined)
    .required(`${e_eps.requiredErrorMsg}`),
    [e_familyCompensation.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined)
    .required(`${e_familyCompensation.requiredErrorMsg}`),
    // [e_fileCajaCompensacion.name]: Yup.string().required(`${e_fileCajaCompensacion.requiredErrorMsg}`),
    [e_cesantias.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined)
    .required(`${e_cesantias.requiredErrorMsg}`),
    // [e_fileCesantias.name]: Yup.string().required(`${e_fileCesantias.requiredErrorMsg}`),
    [e_pension.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined)
    .required(`${e_pension.requiredErrorMsg}`),
    // [e_fileArl.name]: Yup.string().required(`${e_fileArl.requiredErrorMsg}`),
  }),

  // // DOTACION  
  // Yup.object().shape({
  //   // Dotacion fields here if needed
  // })
];   

